import { computed, ref, type Ref } from 'vue';
import type {
  IBattleplanMap,
  IMapArrow,
  IMapIcon,
  IMapLabel,
  IMapObjective,
  IMapTerrain,
  IMapZone,
} from '@scrolldex/shared';
import type { ToolKind } from '../components/editor/labels.js';

export type SelectedMapElement =
  | IMapObjective
  | IMapTerrain
  | IMapZone
  | IMapLabel
  | IMapArrow
  | IMapIcon;

export function useMapSelection(editMap: Ref<IBattleplanMap>) {
  const selectedKind = ref<ToolKind | null>(null);
  const selectedIdx = ref<number | null>(null);

  const selectedElement = computed<SelectedMapElement | null>(() => {
    if (selectedKind.value === null || selectedIdx.value === null) return null;
    const idx = selectedIdx.value;
    switch (selectedKind.value) {
      case 'Objective':
        return editMap.value.objectives[idx] ?? null;
      case 'Terrain':
        return editMap.value.terrain[idx] ?? null;
      case 'Zone':
        return editMap.value.zones[idx] ?? null;
      case 'Label':
        return (editMap.value.labels ?? [])[idx] ?? null;
      case 'Arrow':
        return (editMap.value.arrows ?? [])[idx] ?? null;
      case 'Icon':
        return (editMap.value.icons ?? [])[idx] ?? null;
      default:
        return null;
    }
  });

  function setSelectedElement(kind: ToolKind, idx: number) {
    selectedKind.value = kind;
    selectedIdx.value = idx;
  }

  function deselectElement() {
    selectedKind.value = null;
    selectedIdx.value = null;
  }

  return {
    selectedKind,
    selectedIdx,
    selectedElement,
    setSelectedElement,
    deselectElement,
  };
}
